import http from "../utils/request";

class AdminDataService {
  getActivityJournal(params) {
    return http.get("/api/extra/journal_activities_list", {
      params,
      responseType: params.excel ? "blob" : undefined,
      timeout: 0,
    });
  }

  getAuthJournal(params) {
    return http.get("/api/extra/journal_authorization_list/", {
      params,
      responseType: params.excel ? "blob" : undefined,
      timeout: 0,
    });
  }

  downloadBackup(url) {
    return http.get(`${url}`);
  }

  createBackup() {
    return http.post("/api/extra/back_up_create/");
  }

  createExpertise(a) {
    return http.post("/api/company-objects/epigu_card/", a);
  }

  patchExpertise(data) {
    console.log(data, 'data')
    return http.patch(`/api/company-objects/epigu_card/${data.id}/`, data);
  }

  fetchBackupList(params) {
    return http.get("/api/extra/back_up_list/", {params});
  }

  fetchExpertise(params) {
    return http.get("/api/company-objects/epigu_card/", {params});
  }


  deleteBackup(id) {
    return http.delete(`/api/extra/back_up_delete/${id}`);
  }

  deleteExpertise(id) {
    return http.delete(`/api/company-objects/epigu_card/${id}/`);
  }
}

export default new AdminDataService();
